import PropTypes from 'prop-types';
import { useCallback, useEffect, useMemo, useState } from 'react';
import AppContext from './AppContext';

const DEFAULT_LINK = 'https://8h-3h.com/?id=667299929';

function AppProvider({ children }) {
  const [jogos, setJogos] = useState({});
  const [horario, setHorario] = useState('12:00');
  const [linkSite, setLinkSiteState] = useState(DEFAULT_LINK);

  useEffect(() => {
    fetch(`/config.json?t=${Date.now()}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.meuLink) setLinkSiteState(data.meuLink);
      })
      .catch(() => {});
  }, []);

  const setLinkSite = useCallback((link) => {
    setLinkSiteState(link);
  }, []);

  const values = useMemo(
    () => ({
      jogos,
      setJogos,
      horario,
      setHorario,
      linkSite,
      setLinkSite,
    }),
    [jogos, horario, linkSite, setLinkSite]
  );

  return (
    <AppContext.Provider value={values}>
      {children}
    </AppContext.Provider>
  );
}

AppProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default AppProvider;
